<template>
	<div class="container userinfo-container">

		<div class="head">USERINFO</div>

		<div class="form">
			<div class="form-item clearfix">
				<label class="lt form-label">Name：</label>
				<div class="input-block">
					<input class="input" type="text" name="name" placeholder="" v-model="userinfo.nickname" />
				</div>
			</div>
			<div class="form-item clearfix">
				
				<label class="lt form-label">Gender：</label>
				<div class="input-block">
					<el-radio-group v-model="userinfo.sex">
					    <el-radio :label="1">male</el-radio>

					    <el-radio :label="2">female</el-radio>
					 </el-radio-group>
				</div>
			</div>
			<div class="form-item clearfix">
				<label class="lt form-label">Birth：</label>
				<div class="input-block">
					<el-date-picker 
					    v-model="userinfo.birthdayObj" 
					    type="date" 
					    placeholder="Select a date" 
					    format="yyyy-MM-dd"
					    @change="changedate"
					>
					</el-date-picker>
				</div>
			</div>
			<div class="form-item clearfix">
				<label class="lt form-label">Address：</label>
				<div class="input-block">
					<input class="input" type="text" name="name" placeholder="Detailed address" v-model="userinfo.address" />
				</div>
			</div>
			<div class="form-item clearfix ">
				<label class="lt form-label"></label>
				<div class="input-block">
					<el-button type="success" :loading="loading" @click="save">Save Changes</el-button>
					
				</div>
			</div>
		</div>
	</div>
</template>

<script>


	import {
		mapState
	} from 'vuex'

	export default {
		data() {
			return {
				userinfo:{

				},
				loading: false,
				sexArr: [{
						value: 0,
						text: 'gender'
					},
					{
						value: 1,
						text: 'male'
					},
					{
						value: 2,
						text: 'female'
					}
				],
			
			}
		},
		computed: {

			...mapState({
				userInfo: state => state.userInfo,
				contact: state => state.contact
			}),

			sexTitle() {
				if (!this.userinfo || this.userinfo.sex == 0) {
					return 'gender'
				}
				if (this.userinfo.sex == 1) {
					return 'male'
				}
				if (this.userinfo.sex == 2) {
					return 'female'
				}
			}
		},
		mounted() {
		
			this.getUserInfo();
			
		},
		methods: {
			

            showToast(msg){
                this.global_variable.showToast(msg)
            },
			save() {
				var app = this;

				this.loading = true;

				this.$api("/user/editUserInfo", this.userinfo).then(function(res) {

					app.loading = false;

                    if (res.status == "200") {

                    	app.showToast(res.msg);

                    	app.$store.dispatch('SET_USER', app.userinfo);
                    }
				})
			},
			getUserInfo() {

				var app = this;

				this.$api("/user/getUserInfo", {}).then(function(res) {

					if (res.status == "200") {

						var data = res.data ; 

						app.userinfo =  data


					}

				})
			},
			changedate(date) {
                
				this.userinfo.birthday = this.moment(date).format('YYYY-MM-DD ');
				this.userinfo.birthdayObj = date;

			},
			inputFocus(name) {
				this[name] = true
			},
			inputBlur(name) {
				setTimeout(() => {
					this[name] = false
				}, 200)
			},
			// 选择省份
			selectProvince(id, name, arr) {
				if (id == this.provinceId) {
					return
				}
				this.provinceId = id;
				this.provinceTitle = name;

				this.cityId = 0;
				this.cityTitle = '请选择'
				this.countyId = 0;
				this.countyTitle = '请选择'

				// 城市赋值
				this.$set(this.$data, 'cityArr', arr)
			},
			// 选择城市
			selectCity(id, name, arr) {
				if (id == this.cityId) {
					return
				}
				this.cityId = id;
				this.cityTitle = name;

				this.countyId = 0;
				this.countyTitle = '请选择'

				// 县/区 赋值
				this.$set(this.$data, 'countyArr', arr)
			}
		}
	}
</script>

<style lang="less">
    .user-container{
    	.el-date-editor.el-input, .el-date-editor.el-input__inner{
	    	width:100%;
	    }
    }
    
   
</style>



// WEBPACK FOOTER //
// src/components/ModifyInfo.vue